module.exports = __webpack_public_path__ + "media/images/left-icon-9d50cbac5a07d136439e4a48ba901702.svg";